import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationComputeActiveDataSelector } from "./recommendationComputeActiveDataSelector";

export const recommendationComputeDataLengthSelector = createDraftSafeSelector(
  [recommendationComputeActiveDataSelector],
  (data) => data?.length ?? 0,
);
